import { createContext } from 'react';
import { node, oneOfType, string } from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import getTheme, { themeList } from '../themes';

const ColorModeContext = createContext({ toggleColorMode: () => {} });

export const themeKeys = themeList.map(t => t.key);

export default function EveThemeProvider({ themeKey = 'internal', themeMode = 'light', children }) {
	const theme = getTheme(themeKey, themeMode);
	return (
		<ColorModeContext.Provider value={themeMode}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</ColorModeContext.Provider>
	);
}

/**
 * Storybook's doc-gen does not support dynamic values so themeKey
 * options will be defined as an argType on the story instead
 * See https://github.com/storybookjs/storybook/issues/14092
 */
EveThemeProvider.propTypes = {
	/**
	 * Selected Material UI theme to apply to the provided child structure
	 */
	themeKey: oneOfType([string]),
	/**
	 * Used to nest arbitrary JSX components in EveTheme provider/context
	 */
	children: node.isRequired,
	/**
	 * Theme mode: either light or dark
	 */
	themeMode: oneOfType([string]),
};
